import {appInstance} from '@/utils/app-accessor'

export const srcHost = src =>
    appInstance.$conf.public.routerBase ? appInstance.$conf.public.routerBase.slice(0, -1) + src : src

export const fullUrl = url => useRequestURL().origin + srcHost(url)
